import React, { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { json } from '../../../../api/apiClient';
import { ManaBar, ManaLegend } from '../ManaBars';
import './CommandBridge.css';

/**
 * Mana-Basis: Länder + MDFCs + Farbversorgung + „Anpassen" mit
 * offen sichtbarem Ziel-Feld (keine Klapptür hinter der Klapptür).
 */
export default function ManaBaseSection({ deckStats, canEdit, deckId, onDeckUpdate }) {
  const queryClient = useQueryClient();
  const [targetLands, setTargetLands] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const landCount = deckStats?.landCount ?? 0;
  const target = targetLands ?? Math.max(landCount, 1);
  const targetValue = parseInt(target, 10);
  const hasInvalidTarget = target === '' || Number.isNaN(targetValue) || targetValue < 0;

  const optimize = async () => {
    if (hasInvalidTarget) return;
    const value = targetValue;
    setBusy(true); setError(null);
    try {
      const result = await json(`/api/decks/${encodeURIComponent(deckId)}/optimize-basics`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ targetLandCount: value }),
      });
      onDeckUpdate(() => result);
      queryClient.invalidateQueries({ queryKey: ['deck', deckId] });
    } catch (e) {
      setError('Optimieren fehlgeschlagen — bitte erneut versuchen.');
      console.error('Fehler beim Optimieren der Basics:', e);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="bridge-manabase">
      <div className="bridge-manabase__row">
        <span>Länder</span>
        <span><strong>{landCount}</strong> · davon {deckStats?.mdfcCount ?? 0} MDFC · {deckStats?.basicLandCount ?? 0} Basis-Länder</span>
      </div>
      <ManaBar counts={deckStats?.manaColorCounts || {}} label="Kosten" />
      <ManaBar counts={deckStats?.manaProductionCounts || {}} label="Produktion" />
      <ManaLegend manaColorCounts={deckStats?.manaColorCounts} manaProductionCounts={deckStats?.manaProductionCounts} />
      {canEdit && (
        <>
          <p className="bridge-manabase__hint">
            Füllt die Basis-Länder automatisch passend zur Farbverteilung der Kosten auf.
          </p>
          <div className="bridge-manabase__action">
            <label className="bridge-manabase__target">
              Ziel
              <input
                type="number" min="0" value={target}
                onChange={(e) => setTargetLands(e.target.value)}
                aria-label="Ziel-Länderzahl"
              />
              Länder
            </label>
            <button type="button" className="btn-secondary bridge-manabase__submit" disabled={busy || hasInvalidTarget} onClick={optimize}>
              {busy ? 'Optimiert…' : 'Anpassen'}
            </button>
          </div>
        </>
      )}
      {error && <div className="bridge-manabase__error">{error}</div>}
    </div>
  );
}
